import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading } from "../../repository/slice";

function* addFileToCategoryWorker({ payload }: any): SagaIterator {
    try {
        const formData = new FormData();
        for (const [key, value] of Object.entries(payload as Object)) {
            const isValue = value !== null && value !== undefined && value !== "";
            if (isValue) {
                if (Array.isArray(value)) {
                    value.forEach(file => {
                        formData.append(key, file);
                    });
                } else {
                    formData.append(key, value);
                }
            }
        }; 
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, "/api/admin/category/add-image", formData);
        if (isError) {
            
        } else {
            
        }
    } catch (error) {
        console.error("addFileToCategoryWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* addFileToCategoryWatcher() {
    yield takeLatest("@saga/ADD_FILE_TO_CATEGORY", addFileToCategoryWorker);
};
